export default __webpack_public_path__ + "static/26294-5f31676471bd7f804e5eb4894d35c60f.jpg";